import React from "react"
import { Link } from "react-router-dom"
import zenithSvg from "../../assets/zenith-logo.svg"
import "./BrandLogo.less"

export interface IBrandLogoProps {
  collapsed?: boolean
  size?: "small" | "default" | "large"
  showDemo?: boolean
  linkToHome?: boolean
  className?: string
}

export default function BrandLogo({
  collapsed = false,
  size = "default",
  showDemo = true,
  linkToHome = true,
  className = "",
}: IBrandLogoProps) {
  const content = (
    <div
      className={`zenith-brand-logo ${size} ${collapsed ? "collapsed" : ""} ${className}`}
      title="Zenith Digital - DEMO"
    >
      <div className="logo-icon-wrapper">
        <img src={zenithSvg} alt="Zenith Digital Logo" className="logo-svg-mark" />
        <div className="logo-glow"></div>
        {collapsed && showDemo && (
          <span className="collapsed-demo-badge">DEMO</span>
        )}
      </div>

      {!collapsed && (
        <div className="logo-text-wrapper">
          <div className="brand-header-row">
            <span className="brand-name">ZENITH DIGITAL</span>
          </div>
          <div className="brand-sub-row">
            <span className="brand-tagline">ERP SYSTEM</span>
            {showDemo && (
              <span className="brand-demo-badge">DEMO</span>
            )}
          </div>
        </div>
      )}
    </div>
  )

  if (linkToHome) {
    return (
      <Link to="/" className="zenith-brand-link">
        {content}
      </Link>
    )
  }

  return content
}
